<template>
  <div>
    <v-container class="container_wrap">
      <div class="search_btn_wrap flex jcsb v_center">
        <v-btn :disabled="!user[0].can('manage_offers')" @click="createOffersModel = !createOffersModel" class="mr-3" color="primary">
          <v-icon class="mr-2">mdi-plus</v-icon>
          NEW OFFERS
        </v-btn>
        <v-btn :disabled="!user[0].can('manage_offers')" @click="massOffersModel = !massOffersModel" class="mr-3"  color="primary">
          <v-icon class="mr-2">mdi-upload</v-icon>
          UPLOAD OFFERS
        </v-btn>
        <v-btn :disabled="!user[0].can('manage_offers')" @click="massOffersVariantsModel = !massOffersVariantsModel"  class="mr-3" color="primary">
          <v-icon class="mr-2">mdi-upload</v-icon>
          UPLOAD VARIANTS
        </v-btn>
        <v-btn :disabled="!user[0].can('offers_mass_status')"  @click="massStatusChangeOffers" color="primary" class="btn-inner">
          <v-icon class="mr-2">mdi-swap-horizontal</v-icon>
          Mass Status Change
        </v-btn>

        <v-spacer></v-spacer>

        <div v-if="showCheckBoxes" class="status-change-container flex align-center">
          <v-select
              :items="statusesList"
              item-value="statuses"
              item-text="statuses"
              v-model="selectedStatus"
              label="Change status to"
              class="mr-3"
          />
          <v-btn @click="confirmStatusChange" color="primary" :disabled="!selectedStatus">
            Confirm Status Change
          </v-btn>
          <v-btn @click="reset" color="primary" class="ml-2">Cancel</v-btn>
        </div>

        <template v-if="!showCheckBoxes">
          <span class="inactive_offer_text" v-if="user[0].can('manage_restricted_offers')">Only Restricted</span>
          <v-switch
              v-model="onlyRestricted"
              class="inactive_offer_switch"
              v-if="user[0].can('manage_restricted_offers')"
          >
          </v-switch>
          <span class="inactive_offer_text">Show inactive</span>
          <v-switch
              v-model="showInactiveOffers"
              class="inactive_offer_switch"
          >
          </v-switch>
          <div class="search_wrapper">
            <v-text-field
                v-model="table.searchInOffers"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
          </div>
        </template>
      </div>
    <v-card>

    <v-data-table
        v-model="offersData"
        :header-props="{ sortIcon: null }"
        :headers="table.headers"
        :items="getOffers.data"
        :server-items-length="getOffers.count"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :disable-sort="true"
        :loading="table.loading"
        :page="table.currentPage"
        fixed-header
        loading-text="Loading... Please wait"
        :class="`elevation-1 fixed-height items-size-${table.heightCounter}`"
        color="#7F98A5"
        @pagination="updateTablePagination"
        :show-select="showCheckBoxes"
    >
      <template v-slot:header.id="{ header }">
        <a @click="table.showFilters.id = !table.showFilters.id">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.id || table.activeFilters.id ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('id')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.id.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.id" ref="id-filter" class="modal-data"
             id="id-filter">
          <filter-modal
              :storeData="getOfferIds"
              :dataProperty="'ids'"
              :formName="'id'"
              :modalName="'id'"
              :isShown="table.showFilters.id"
              :usedFilters="table.selectedFilters.id"
              @hideModal="closeFilter($event)"
              @idFilterChange="table.selectedFilters.id = $event"
              @idFilter="submitFilter()"
              @idSearch="updateDataInFilters($event, 'id',  table.selectedFilters)"
          ></filter-modal>
        </div>
      </template>

      <template v-slot:header.status="{ header }">
        <a @click="table.showFilters.status = !table.showFilters.status">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.status || table.activeFilters.status ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('status')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.status.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.status" ref="status-filter" class="modal-data"
             id="status-filter">
          <filter-modal
              :storeData="getOfferStatuses"
              :dataProperty="'statuses'"
              :formName="'status'"
              :modalName="'status'"
              :isShown="table.showFilters.status"
              :usedFilters="table.selectedFilters.status"
              @hideModal="closeFilter($event)"
              @statusFilterChange="table.selectedFilters.status = $event"
              @statusFilter="submitFilter()"
              @statusSearch="updateDataInFilters($event, 'status',  table.selectedFilters)"
          ></filter-modal>
        </div>

      </template>

      <template v-slot:header.type="{ header }">
        <a @click="table.showFilters.type = !table.showFilters.type">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.type || table.activeFilters.type ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('type')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.type.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.type" ref="type-filter" class="modal-data"
             id="type-filter">
          <filter-modal
              :storeData="getOfferType"
              :dataProperty="'types'"
              :formName="'type'"
              :modalName="'type'"
              :isShown="table.showFilters.type"
              :usedFilters="table.selectedFilters.type"
              @hideModal="closeFilter($event)"
              @typeFilterChange="table.selectedFilters.type = $event"
              @typeFilter="submitFilter()"
              @typeSearch="updateDataInFilters($event, 'type',  table.selectedFilters)"
          ></filter-modal>
        </div>
      </template>


      <template v-slot:header.advertiserName="{ header }">
        <a @click="table.showFilters.advertiserName = !table.showFilters.advertiserName">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.advertiserName || table.activeFilters.advertiserName ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('advertiserName')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.advertiserName.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.advertiserName" ref="advertiser-name-filter" class="modal-data"
             id="advertiser-name-filter">
          <filter-modal
              :storeData="getOfferAdvertiserNames"
              :dataProperty="'advertiserName'"
              :formName="'advertiserName'"
              :modalName="'advertiserName'"
              :isShown="table.showFilters.advertiserName"
              :usedFilters="table.selectedFilters.advertiserName"
              @hideModal="closeFilter($event)"
              @advertiserNameFilterChange="table.selectedFilters.advertiserName = $event"
              @advertiserNameFilter="submitFilter()"
              @advertiserNameSearch="updateDataInFilters($event, 'advertiserName')"
          ></filter-modal>
        </div>

      </template>

      <template v-slot:header.externalId="{ header }">
        <a @click="table.showFilters.externalId = !table.showFilters.externalId">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.externalId || table.activeFilters.externalId ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('externalId')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.externalId.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.externalId" ref="external-id-filter" class="modal-data"
             id="external-id-filter">
          <filter-modal
              :storeData="getOfferExternalIds"
              :dataProperty="'externalId'"
              :formName="'externalId'"
              :modalName="'externalId'"
              :isShown="table.showFilters.externalId"
              :usedFilters="table.selectedFilters.externalId"
              @hideModal="closeFilter($event)"
              @externalIdFilterChange="table.selectedFilters.externalId = $event"
              @externalIdFilter="submitFilter()"
              @externalIdSearch="updateDataInFilters($event, 'externalId',  table.selectedFilters)"
          ></filter-modal>
        </div>
      </template>

      <template v-slot:header.managerName="{ header }">
        <a @click="table.showFilters.managerName = !table.showFilters.managerName">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.managerName || table.activeFilters.managerName ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('managerName')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.managerName.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.managerName" ref="advertiser-name-filter" class="modal-data"
             id="advertiser-name-filter">
          <filter-modal
              :storeData="getOfferManagerNames"
              :dataProperty="'managerName'"
              :formName="'managerName'"
              :modalName="'managerName'"
              :isShown="table.showFilters.managerName"
              :usedFilters="table.selectedFilters.managerName"
              @hideModal="closeFilter($event)"
              @managerNameFilterChange="table.selectedFilters.managerName = $event"
              @managerNameFilter="submitFilter()"
              @managerNameSearch="updateDataInFilters($event, 'managerName', table.selectedFilters)"
          ></filter-modal>
        </div>

      </template>

      <template v-slot:header.verticalName="{ header }">
        <a @click="table.showFilters.verticalName = !table.showFilters.verticalName">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.verticalName || table.activeFilters.verticalName ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('verticalName')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.verticalName.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.verticalName" ref="vertical-name-filter" class="modal-data"
             id="vertica-name-filter">
          <filter-modal
              :storeData="getOfferVerticalsNames"
              :dataProperty="'verticalName'"
              :formName="'vertical-name'"
              :modalName="'verticalName'"
              :isShown="table.showFilters.verticalName"
              :usedFilters="table.selectedFilters.verticalName"
              @hideModal="closeFilter($event)"
              @verticalNameFilterChange="table.selectedFilters.verticalName = $event"
              @verticalNameFilter="submitFilter()"
              @verticalNameSearch="updateDataInFilters($event, 'verticalName')"
          ></filter-modal>
        </div>
      </template>

      <template v-slot:header.name="{ header }">
        <a @click="table.showFilters.name = !table.showFilters.name">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.name || table.activeFilters.name ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('name')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.name.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.name" ref="name-filter" class="modal-data"
             id="name-filter">
          <filter-modal
              :storeData="getOfferNames"
              :dataProperty="'name'"
              :formName="'name'"
              :modalName="'name'"
              :isShown="table.showFilters.name"
              :usedFilters="table.selectedFilters.name"
              @hideModal="closeFilter($event)"
              @nameFilterChange="table.selectedFilters.name = $event"
              @nameFilter="submitFilter()"
              @nameSearch="updateDataInFilters($event, 'name')"
          ></filter-modal>
        </div>

      </template>

      <template v-slot:header.payIn="{ header }">

        <a @click="table.showFilters.payIn = !table.showFilters.payIn">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.payIn || table.activeFilters.payIn ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('payIn')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.payIn.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.payIn" ref="payIn-filter" class="modal-data"
             id="payIn-filter">
          <filter-modal
              :storeData="getOfferPaysIn"
              :dataProperty="'payIn'"
              :formName="'payIn'"
              :modalName="'payIn'"
              :isShown="table.showFilters.payIn"
              :usedFilters="table.selectedFilters.payIn"
              @hideModal="closeFilter($event)"
              @payInFilterChange="table.selectedFilters.payIn = $event"
              @payInFilter="submitFilter()"
              @payInSearch="updateDataInFilters($event, 'payIn')"
          ></filter-modal>
        </div>

      </template>

      <template v-slot:item.payIn="{ item }">
        <span class="offer-payIn" v-if="item.minPayIn && item.maxPayIn && (item.minPayIn !== item.maxPayIn)" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{item.currencySymbol}}{{Math.round(item.minPayIn)}} - {{item.currencySymbol}}{{Math.round(item.maxPayIn)}}
          </span>
          <span class="offer-payIn" v-else v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{item.currencySymbol}}{{item.minPayIn || item.payIn}}
          </span>
      </template>

      <template v-slot:header.programName="{ header }">
        <a @click="table.showFilters.programName = !table.showFilters.programName">
          <v-icon size="16" color="#7F98A5">{{
            table.showFilters.programName || table.activeFilters.programName ? 'mdi-filter' :
            'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
                @click="sortColumn('programName')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.programName.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.programName" ref="program-name-filter" class="modal-data"
             id="program-name-filter">
          <filter-modal
                  :storeData="getOfferPrograms"
                  :dataProperty="'programName'"
                  :formName="'programName'"
                  :modalName="'programName'"
                  :isShown="table.showFilters.programName"
                  :usedFilters="table.selectedFilters.programName"
                  @hideModal="closeFilter($event)"
                  @programNameFilterChange="table.selectedFilters.programName = $event"
                  @programNameFilter="submitFilter()"
                  @programNameSearch="updateDataInFilters($event, 'programName')"
          ></filter-modal>
        </div>

      </template>

      <template v-slot:header.payOut="{ header }">
        <a @click="table.showFilters.payOut = !table.showFilters.payOut">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.payOut || table.activeFilters.payOut ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('payOut')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.payOut.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.payOut" ref="payOut-filter" class="modal-data"
             id="payOut-filter">
          <filter-modal
              :storeData="getOfferPaysOut"
              :dataProperty="'payOut'"
              :formName="'payOut'"
              :modalName="'payOut'"
              :isShown="table.showFilters.payOut"
              :usedFilters="table.selectedFilters.payOut"
              @hideModal="closeFilter($event)"
              @payOutFilterChange="table.selectedFilters.payOut = $event"
              @payOutFilter="submitFilter()"
              @payOutSearch="updateDataInFilters($event, 'payOut')"
          ></filter-modal>
        </div>
      </template>

      <template v-slot:item.id="{ item }">
        <template v-if="showCheckBoxes">
          <td>
            <v-checkbox
                :value="item.id"
            />
          </td>
        </template>
      </template>
      <template v-slot:item.payOut="{ item }">
          <span class="offer-payOut" v-if="item.minPayOut && item.maxPayOut && (item.minPayOut !== item.maxPayOut)"
                v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{item.currencySymbol}}{{Math.round(item.minPayOut)}} - {{item.currencySymbol}}{{Math.round(item.maxPayOut)}}
          </span>
          <span v-else class="offer-payOut" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{item.currencySymbol}}{{item.minPayOut || item.payOut}}
          </span>
      </template>

      <template v-slot:header.currencyId="{ header }">
        <a @click="table.showFilters.currencyId = !table.showFilters.currencyId">
          <v-icon size="16" color="#7F98A5">{{
              table.showFilters.currencyId || table.activeFilters.currencyId ? 'mdi-filter' :
                  'mdi-filter-outline'
            }}
          </v-icon>
        </a>
        <a
            @click="sortColumn('currencyName')"
        >
          <span class="header_title">{{ header.text }}</span>
          <v-icon size="16" color="#7F98A5"> {{ table.switchSortIcon.currencyId.icon }}</v-icon>
        </a>
        <div v-show="table.showFilters.currencyId" ref="currencyId-filter" class="modal-data"
             id="currencyId-filter">
          <filter-modal
              :storeData="getOfferCurrencies"
              :dataProperty="'currencyName'"
              :formName="'currencyId'"
              :modalName="'currencyId'"
              :isShown="table.showFilters.currencyId"
              :usedFilters="table.selectedFilters.currencyId"
              @hideModal="closeFilter($event)"
              @currencyIdFilterChange="table.selectedFilters.currencyId = $event"
              @currencyIdFilter="submitFilter()"
              @currencyIdSearch="updateDataInFilters($event, 'currencyId')"
          ></filter-modal>
        </div>
      </template>

      <template v-slot:item.currencyId="{ item }">
          <span class="offer-status" v-if="item.currencyId === 1">
            USD
          </span>
        <span class="offer-status" v-else-if="item.currencyId === 2">
            EUR
          </span>
        <span class="offer-status" v-else-if="item.currencyId === 3">
            BRL
          </span>
        <span class="offer-status" v-else-if="item.currencyId === 4">
            GBP
          </span>
      </template>

      <template v-slot:header.actions="{ header }">
        <span class="header_title">{{ header.text }}</span>
      </template>

      <!--body-->
      <template v-slot:item.id="{item}">
        <td :style="{height: table.heightCounter + 'px'}"
            class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
          {{ item.id }}
        </td>
      </template>

      <template v-slot:item.name="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
             <a class="entity-link" @click="showCard(item)">{{item.name}}</a>
          </span>
      </template>

      <template v-slot:item.status="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{ item.status }}
          </span>
      </template>

      <template v-slot:item.type="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{ item.type }}
          </span>
      </template>

      <template v-slot:item.programName="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
             <a class="entity-link" @click="showCard(item, 'program')">{{item.programName}}</a>
          </span>
      </template>

      <template v-slot:item.currencyId="{item}">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
                v-bind="attrs"
                v-on="on"
                class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }"
            >
              {{ item.currencySymbol }}
            </span>
          </template>
          <span>{{ item.currencyName }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.verticalName="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{ item.verticalName }}
          </span>
      </template>

      <template v-slot:item.advertiserName="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{ item.advertiserName }}
          </span>
      </template>

      <template v-slot:item.externalId="{item}">
          <span class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }">
            {{ item.externalId }}
          </span>
      </template>

      <template v-slot:item.internalNotes="{item}">
          <span class="td_title">
            {{ item.internalNotes }}
          </span>
      </template>

      <template v-slot:item.actions="{item}">
        <!-- <button
                @click="editOffer(item.id)"
                class="td_title btn btn-link"
        >
          <v-icon size="16" color="#7F98A5" style="cursor:pointer;">mdi-message-text</v-icon>
        </button> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!user[0].can('manage_offers')"
                    @click="createCampaignModal(item)"
                    class="td_title btn btn-link"
            >
              <i class="far fa-bullhorn"></i>
            </button>
          </template>
          <span>Create campaign</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a
                v-bind="attrs"
                v-on="on"
                :href="getEditOfferUrl(item)"
                :disabled="!user[0].can('manage_offers')"
                target="_blank"
                class="td_title btn btn-link"
            >
              <i class="far fa-pencil"></i>
            </a>
          </template>
          <span>Edit Offer</span>
        </v-tooltip>
<!--        <v-tooltip bottom>-->
<!--          <template v-slot:activator="{ on, attrs }">-->
<!--            <a-->
<!--              v-bind="attrs"-->
<!--              v-on="on"-->
<!--              :href="getEditOfferUrlV2(item)"-->
<!--              :disabled="!user[0].can('manage_offers')"-->
<!--              target="_blank"-->
<!--              class="td_title btn btn-link"-->
<!--            >-->
<!--              <i class="fas fa-tools"></i>-->

<!--            </a>-->
<!--          </template>-->
<!--          <span>Edit Offer V2</span>-->
<!--        </v-tooltip>-->
        <v-tooltip v-if="item.type === 'regular'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
                v-bind="attrs"
                v-on="on"
                @click="copyOffer(item)"
                :disabled="!user[0].can('manage_offers')"
                class="td_title btn btn-link"
            >
              <i class="far fa-copy"></i>
            </button>
          </template>
          <span>Copy Offer</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
                v-bind="attrs"
                v-on="on"
                @click="deleteOffer(item.id)"
                :disabled="!user[0].can('manage_offers')"
                class="td_title btn btn-link"
            >
              <i class="far fa-trash"></i>
            </button>
          </template>
          <span>Delete Offer</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a
                  class="no-underline"
                 :href="getReportsUrl(item)"
                 v-bind="attrs"
                 v-on="on"
                 target="_blank"
              >
                <v-icon color="accent">fal fa-analytics</v-icon>
              </a>
            </template>

          <span>Reports</span>
        </v-tooltip>
      </template>

      <template v-slot:item.landingPageUrl="{item}">
        <span
            v-if="item.type !== 'aggregated'"
            class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }"
            :title="item.landingPageUrl"
        >
            {{ item.landingPageUrl && item.landingPageUrl.length <= 25 ? item.landingPageUrl : item.landingPageUrl && item.landingPageUrl.substring(0, 25) + "..."  }}
          </span>
        <span v-else
              class="td_title" v-bind:class="{ td_title_inactive_offer: item.status === 'inactive' }"
              :title="item.aggregatedOfferLPurl"
        >
            {{ item.aggregatedOfferLPurl && item.aggregatedOfferLPurl.length <= 25 ? item.aggregatedOfferLPurl : item.aggregatedOfferLPurl && item.aggregatedOfferLPurl.substring(0, 25) + "..."  }}
            <v-chip
                v-if="item.aggregatedOfferLPcount !== 0"
                @click="onLandingPageDetails(item.id)"
                class="td_title px-1"
                color="primary"
            >
                +{{item.aggregatedOfferLPcount}}
            </v-chip>
        </span>
      </template>
    </v-data-table>
<!--    <v-card-title>-->
<!--      <v-spacer></v-spacer>-->
<!--      <div class="search_wrap">-->
<!--        <v-text-field-->
<!--          v-model="search"-->
<!--          append-icon="mdi-magnify"-->
<!--          label="Search"-->
<!--          single-line-->
<!--          hide-details-->
<!--        ></v-text-field>-->
<!--      </div>-->
<!--    </v-card-title>-->

  </v-card>

    </v-container>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <MassOffersUpload v-model="massOffersModel"></MassOffersUpload>
    <MassVariantsUpload v-model="massOffersVariantsModel"></MassVariantsUpload>
    <CreateOffer v-model="createOffersModel"></CreateOffer>
    <NewCampaign v-model="addCampaigns" :offer="currentOffer"/>
  </div>
</template>

<script>
  import MainLayout from "../../layouts/MainLayout"
  import {mapActions, mapGetters, mapState} from 'vuex'
  import store from '../../../store'
  import {getCookie} from "@/helpers"

  import MassOffersUpload from "./offers/MassOffersUpload.vue";
  import MassVariantsUpload from "./offers/MassVariantsUpload.vue";
  import CreateOffer from "./offers/CreateOffer.vue";
  import programsApi from "@/api/programs";
  import {debounce} from "debounce";
  import NewCampaign from "@/components/pages/affiliates/campaigns/NewCampaign";
  import offers from "@/api/offers";

  export default {
    data() {
      return {
        statusesList: [],
        selectedStatus: null,
        showCheckBoxes: false,
        offersData:[],
        ids:[],
        currentAction: null,
        search: '',
        addCampaigns: false,
        currentOffer: null,
        massOffersModel: false,
        massOffersVariantsModel: false,
        createOffersModel: false,
        loading: false,
        showInactiveOffers: false,
        onlyRestricted: false,
        table: {
          heightCounter: 45,
          loading: false,
          searchInOffers: '',
          pageChangedByMe: false,
          currentPage: 1,
          perPage: 10,
          pageOptions: [25, 50, 100, 200, 500],
          orderBy: '',
          sortColumnsAsc: {
            id: null,
            name: null,
            status: null,
            type: null,
            advertiserId: null,
            advertiserName: null,
            verticalName: null,
            externalId: null,
            payIn: null,
            payOut: null,
            currencyId: null,
            programName: null
          },
          switchSortIcon: {
            id: {switch: false, icon: 'mdi-arrow-up-down'},
            advertiserId: {switch: false, icon: 'mdi-arrow-up-down'},
            name: {switch: false, icon: 'mdi-arrow-up-down'},
            advertiserName: {switch: false, icon: 'mdi-arrow-up-down'},
            managerName: {switch: false, icon: 'mdi-arrow-up-down'},
            verticalName: {switch: false, icon: 'mdi-arrow-up-down'},
            externalId: {switch: false, icon: 'mdi-arrow-up-down'},
            payIn: {switch: false, icon: 'mdi-arrow-up-down'},
            payOut: {switch: false, icon: 'mdi-arrow-up-down'},
            status: {switch: false, icon: 'mdi-arrow-up-down'},
            type: {switch: false, icon: 'mdi-arrow-up-down'},
            currencyId: {switch: false, icon: 'mdi-arrow-up-down'},
            programName: {switch: false, icon: 'mdi-arrow-up-down'}
          },
          showFilters: {
            id: false,
            advertiserId: false,
            name: false,
            advertiserName: false,
            managerName: false,
            verticalName: false,
            externalId: false,
            payIn: false,
            payOut: false,
            status: false,
            type: false,
            currencyId: false,
            programName: false
          },
          activeFilters: {
            id: false,
            advertiserId: false,
            name: false,
            advertiserName: false,
            externalId: false,
            managerName: false,
            verticalName: false,
            payIn: false,
            payOut: false,
            status: false,
            type: false,
            currencyId: false,
            programName: false
          },
          selectedFilters: {
            id: [],
            advertiserId: [],
            name: [],
            advertiserName: [],
            externalId: [],
            managerName: [],
            verticalName: [],
            payIn: [],
            payOut: [],
            status: [],
            type: [],
            currencyId: [],
            programName: []
          },
          selectedOffers: [],
          headers: [
            {
              text: 'ID',
              align: 'start',
              value: 'id',
            },
            {text: 'Name', value: 'name'},
            {text: 'Status', value: 'status'},
            {text: 'Type', value: 'type'},
            {text: 'Program', value: 'programName'},
            // {text: 'Payin', value: 'payIn'},
            // {text: 'Payout', value: 'payOut'},
            {text: 'Currency', value: 'currencyId', align: 'center'},
            {text: 'Vertical', value: 'verticalName'},
            {text: 'ExternalId', value: 'externalId'},
            {text: 'Advertiser', value: 'advertiserName'},
            {text: 'Offer Manager', value: 'managerName'},
            {text: 'Internal Notes', value: 'internalNotes'},
            {text: 'Actions', value: 'actions', align: 'center'},
            // {text: 'Campaigns', value: 'countOfCampaigns'},
            {text: 'URL', value: 'landingPageUrl'},
          ],
        }
      }
    },
    async created() {
      if (!this.user[0].can('read_offers')
          && !this.user[0].can('manage_offers')
      ){
        await this.$router.push('/403');
      }
    },
    async mounted() {
      this.getGeneralData()
      if (this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
      await this.submitFilter();
    },

    components: {
      MainLayout,
      MassOffersUpload,
      MassVariantsUpload,
      CreateOffer,
      NewCampaign
    },
    watch: {
      'table.searchInOffers'() {
        if (this.table.searchInOffers.length > 1) {
          return this.submitFilter()
        }
        if (this.table.searchInOffers === '') {
          return this.submitFilter()
        }
      },
      showInactiveOffers: async function () {
        await this.submitFilter()
      },
      onlyRestricted: async function () {
        await this.submitFilter()
      },
    },
    computed: {
      ...mapState('user', ['user']),
      ...mapGetters('programs', ['programs']),
      ...mapGetters('offers', [
        'getOffers',
        'getOfferAdvertiserIds',
        'getOfferExternalIds',
        'getOfferAdvertiserNames',
        'getOfferManagerNames',
        'getOfferVerticalsNames',
        'getOfferStatuses',
        'getOfferType',
        'getOfferIds',
        'getMultiplySelectOffers',
        'getOfferNames',
        'getOfferPaysIn',
        'getOfferPaysOut',
        'getOfferCurrencies',
        'getOfferPrograms'
      ]),
    },
    methods: {
      async massStatusChangeOffers() {
        this.currentAction = 'statusChange';
        this.toggleShowCheckBoxes();

        try {
          const filters = {
            "filters": {
            "id": null,
                "names": null,
                "advertiserIds": null,
                "advertiserNames": null,
                "managerNames": null,
                "verticalNames": null,
                "paysIn": null,
                "paysOut": null,
                "statuses": null,
                "type": null,
                "currencies": null,
                "programNames": null
            }
          }
          const statuses  = await offers.getSflOfferStatuses(filters)

          this.statusesList = statuses.map(status => status.statuses);
        } catch (err) {
          store.dispatch('alert/ALERT_ERROR', err.message, { root: true });
        }
      },

      async confirm() {
        if (this.currentAction === 'statusChange') {
          return this.confirmStatusChange();
        }
      },

      async confirmStatusChange() {
        if (!this.selectedStatus) {
          store.dispatch('alert/ALERT_ERROR', 'Please select a status to update the offers', { root: true });
          return;
        }
        if (!this.offersData.length) {
          store.dispatch('alert/ALERT_ERROR', 'Please select one or more offers to change status', { root: true });
          return;
        }

        try {

          const offerIds = this.offersData.map(item=>item.id)
          await store.dispatch('offers/massStatusUpdate', {
            newStatus: this.selectedStatus,
            offerIds
          });
          store.dispatch('alert/ALERT_SUCCESS', 'Status updated successfully', { root: true });
        } catch (err) {
          store.dispatch('alert/ALERT_ERROR', err.message, { root: true });
        }

        this.reset();
      },

      reset() {
        this.toggleShowCheckBoxes();
        this.currentAction = '';
        this.offersData = [];
        this.selectedStatus = null;
      },
      cancel() {
        this.reset();
      },
      toggleShowCheckBoxes() {
        this.showCheckBoxes = !this.showCheckBoxes;
      },

      async copyOffer(item) {
        const offerId = item.id
        let resDb = await store.dispatch('offers/createDuplicateOffer', {offerId})
        if (resDb && resDb.success === true) {
          await this.$dialog.notify.success('Offer copied', {
            position: 'top-right',
            timeout: 1000
          })
        } else {
          await this.$dialog.error({
            text: `offer was not copied`,
            title: 'Please check backend errors'
          })
        }
      },
      createCampaignModal(item) {
        this.currentOffer = item;
        this.addCampaigns = true;
      },
      getEditOfferUrl(item) {
        if (item.type === 'aggregated') {
          return `/advertisers/aggregatedOffer/${item.id}`;
        } else {
          return `/advertisers/offerV2/${item.id}`;
        }
      },
      getEditOfferUrlV2(item) {
        if (item.type === 'aggregated') {
          return `/advertisers/aggregatedOffer/${item.id}`;
        } else {
          return `/advertisers/offerV2/${item.id}`;
        }
      },
      editOffer(item) {
        if (item.type === 'aggregated'){
          this.$router.push(`/advertisers/aggregatedOffer/${item.id}`);
        } else {
          this.$router.push(`/advertisers/offerV2/${item.id}`);
        }
      },
      async onLandingPageDetails(id){
         await store.dispatch('cards/ADD', {
            type: 'offerAggregatedLPCard',
            title: id,
            key: `offerAggregatedLPCard-${id}`,
            data: {
              id: id
            }
          })
      },
      getReportsUrl(item) {
        const filters = '?filters=' + encodeURI(JSON.stringify({field: 'offer_id', value: [`${item.id}`]}))
        return '/analytics/reports/offers' + filters;
      },
      async deleteOffer(offerId) {
        let confirmDelOffer = await this.$dialog.warning({
          text: `Are you sure?`,
          title: `Record ${offerId} will be delete.`
        })

        if (confirmDelOffer) {
          this.loading = true
          let resDb = await store.dispatch('offers/delOffer', {id: offerId})
          if (resDb && resDb.id) {
            this.loading = false
            await this.submitFilter();
            await this.$dialog.notify.success('Record deleted', {
              position: 'top-right',
              timeout: 5000
            })
          } else {
            this.loading = false
            await this.$dialog.error({
              text: `Record was not deleted`,
              title: 'Please check backend errors'
            })
          }
        }
      },
      enterSelect(values) {
        // console.log('enterSelect:', values)
        this.table.selectedOffers.length = 0
        let formatAff = values.map(i => (i.id)).join(",");
        this.table.selectedOffers.push(formatAff)
        this.saveMultiplySelectOffers(formatAff)
      },
      updateDataInFilters(data, modalName, filters) {
        this.debounceUpdateDataInFilters(data, modalName, filters)
      },
      debounceUpdateDataInFilters: debounce((data, modalName, filters) => {
        let filtersClone = {}

        let filtersMap = {
          ids: 'id',
          names: 'name',
          advertiserIds: 'advertiserId',
          advertiserNames: 'advertiserName',
          externalIds: 'externalId',
          managerNames: 'managerName',
          verticalNames: 'verticalName',
          paysIn: 'payIn',
          paysOut: 'payOut',
          statuses: 'status',
          type: 'type',
          currencies: 'currencyId',
          programNames: 'programName'
        }
        if (!filters) {
          console.warn('Filters object is undefined. Initializing as an empty object.');
          filters = {};
        }
        for (const name in filtersMap) {
          if (filters[filtersMap[name]] && Array.isArray(filters[filtersMap[name]]) && filters[filtersMap[name]].length > 0) {
            filtersClone[name] = `${filters[filtersMap[name]].join('\',\'')}`;
          } else {
            filtersClone[name] = null;
          }
        }

        switch (modalName) {
          case 'id':
            filtersClone.ids = data
            store.dispatch('offers/saveOfferIdsStore', {filters: filtersClone})
            break
          case 'name':
            filtersClone.searchOfferNames = data
            store.dispatch('offers/saveOfferNamesStore', {filters: filtersClone})
            break
          case 'payIn':
            store.dispatch('offers/saveOfferPaysInStore', {search: data})
            break
          case 'payOut':
            store.dispatch('offers/saveOfferPaysOutStore', {search: data})
            break
          case 'advertiserName':
            filtersClone.searchAdvertiserNames = data
            store.dispatch('offers/saveOfferAdvertiserNamesStore', {filters: filtersClone})
            break
          case 'externalId':
            filtersClone.searchExternalId = data
            store.dispatch('offers/saveOfferExternalIdsStore', {filters: filtersClone})
            break
          case 'managerName':
            filtersClone.searchManagerNames = data
            store.dispatch('offers/saveOfferManagerNamesStore', {filters: filtersClone})
            break
          case 'programName':
            filtersClone.searchProgramNames = data
            store.dispatch('offers/saveOfferProgramNamesStore', {filters: filtersClone})
            break
          case 'verticalName':
            filtersClone.searchVerticalName = data
            store.dispatch('offers/saveOfferVerticalNamesStore', {filters: filtersClone})
            break
          case 'advertiserId':
            store.dispatch('offers/saveOfferAdvertiserIdsStore', {search: data})
            break
          case 'status':
            filtersClone.searchStatus = data
            store.dispatch('offers/saveOfferStatusesStore', {filters: filtersClone})
            break
          case 'type':
            filtersClone.searchType = data
            store.dispatch('offers/saveOfferTypeStore', {filters: filtersClone})
            break
        }
      }, 700),
      async sortColumn(column) {
        this.table.orderBy = column
        this.table.sortColumnsAsc[column] = (!(this.table.sortColumnsAsc[column] || this.table.sortColumnsAsc[column] === null))
        await this.getTableData()
        this.switcherSortIcon(column)
      },
      switcherSortIcon(column) {
        if(this.table.switchSortIcon[column].switch) {
          this.table.switchSortIcon[column].icon = 'mdi-arrow-up'
          this.table.switchSortIcon[column].switch = !this.table.switchSortIcon[column].switch

        } else {
          this.table.switchSortIcon[column].icon = 'mdi-arrow-down'
          this.table.switchSortIcon[column].switch = !this.table.switchSortIcon[column].switch
        }
      },
      updateFiltersFromQuery() {
        let filtersMap = {
          id: 'ids',
          name: 'names',
          advertiserId: 'advertiserIds',
          advertiserName: 'advertiserNames',
          externalId: 'externalIds',
          managerName: 'managerNames',
          verticalName: 'verticalNames',
          payIn: 'paysIn',
          payOut: 'paysOut',
          status: 'statuses',
          currencyId: 'currencies',
          programName: 'programNames'
        }
        const queryFilters = JSON.parse(this.$route.query.filters);
        for (const name in this.table.selectedFilters) {
          if (queryFilters[filtersMap[name]]) {
            this.table.selectedFilters[name] = queryFilters[filtersMap[name]];
          }
        }
      },
      updateTablePagination(params) {
        // if (
        //     (this.table.currentPage === params.page &&
        //         this.table.perPage === params.itemsPerPage) ||
        //     this.table.pageChangedByMe
        // ) {
        //   this.table.pageChangedByMe = false;
        //   return
        // }
        this.table.currentPage = params.page
        this.table.perPage = params.itemsPerPage
        if(this.$route.query.filters) {
          this.updateFiltersFromQuery();
        }
        this.submitFilter();
      },
      closeFilter(modal) {
        this.table.showFilters[modal] = !this.table.showFilters[modal]
        this.table.showFilters.programName = false
      },
      async submitFilter() {
        this.closeAllFilters()
        this.activateFilters()

        let filtersMap = {
          id: 'id',
          names: 'name',
          advertiserIds: 'advertiserId',
          advertiserNames: 'advertiserName',
          externalIds: 'externalId',
          managerNames: 'managerName',
          verticalNames: 'verticalName',
          paysIn: 'payIn',
          paysOut: 'payOut',
          statuses: 'status',
          type: 'type',
          currencies: 'currencyId',
          programNames: 'programName'
        }

        let filters = {};
        const filtersForQuery = {};
        for (const name in filtersMap) {
          if (this.table.selectedFilters[filtersMap[name]].length > 0) {
            filtersForQuery[name] = this.table.selectedFilters[filtersMap[name]];
            filters[name] = `${this.table.selectedFilters[filtersMap[name]].join('\',\'')}`
          } else {
            filters[name] = null;
          }
        }
        this.addParamsToLocation(
            JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
        );
        return await this.getTableData(filters)
      },
      async getTableData(filters) {
        this.table.loading = true
        if (this.table.searchInOffers.length > 0) {
          filters['search'] = this.table.searchInOffers
        }
        await store.dispatch('offers/saveOffersStore', {
            byColumn: this.table.orderBy.split(/(?=[A-Z])/).join('_').toLowerCase(),
            ascending: this.table.sortColumnsAsc[this.table.orderBy],
            page: this.table.currentPage,
            limit: this.table.perPage,
            filters: filters || null,
            token: getCookie('accessToken'),
            showInactiveOffers: this.showInactiveOffers,
            onlyRestricted: this.onlyRestricted
        })
        await store.dispatch('offers/saveOfferNamesStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferAdvertiserNamesStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferExternalIdsStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferManagerNamesStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferProgramNamesStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferVerticalNamesStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferStatusesStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferTypeStore', {
          filters: filters || null,
        })

        await store.dispatch('offers/saveOfferIdsStore', {
          filters: filters || null,
        })

        this.table.loading = false

      },

      async showCard(item, column=null) {
        if (column && column === 'program') {
          const programData = await programsApi.getPrograms({
            limit: 1, page: 1, orderBy: 'id', orderDirectionAsc: true,
            filters: {id: item.programId}
          });
          if (!programData || !programData.programs || !programData.programs.length) {
            return ;
          }
          const program = programData.programs[0];
          store.dispatch('cards/ADD', {
            type: 'program',
            title: `[${program.id}] - [${program.name}]`,
            key: `program-${program.id}`,
            data: program
          });
          return;
        }

        store.dispatch('cards/ADD', {
          type: 'offer',
          title: `[${item.id}] - [${item.name}] : [${item.status}]`,
          key: `offer-${item.id}`,
          data: item
        })
      },
      async redirectProgram({programId,programName}) {
        let filters = {
          name: programName
        }
        await store.dispatch('programs/getPrograms', {
          limit: 1,
          page: 0,
          orderBy: true,
          orderDirectionAsc: true,
          filters: filters || null
        });

        const program = this.programs[0];
        if (program) {
          localStorage.setItem("program", JSON.stringify(program));
          await this.$router.push(`/advertisers/programs/edit/${programId}`);
        }
      },
      closeAllFilters() {
        this.table.showFilters = {
          id: false,
          name: false,
          advertiserId: false,
          advertiserName: false,
          externalId: false,
          managerName: false,
          verticalName: false,
          payIn: false,
          payOut: false,
          status: false,
          type: false,
          currencyId: false,
          programName: false
        }
      },
      activateFilters() {
        Object.keys(this.table.selectedFilters).forEach(value => {
          this.table.activeFilters[value] = (this.table.selectedFilters[value].length > 0)
        })
      },
      addParamsToLocation(params) {
        const query = JSON.stringify(params) === '{}' ? this.$route.path :
            this.$route.path + '?' + Object.keys(params).map(
            key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
            ).join('&')
        history.pushState({}, null, query);
      },
      ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
      getGeneralData() {
        // await this.getTableData()
        store.dispatch('offers/saveOfferAdvertiserIdsStore')
        store.dispatch('offers/saveOfferAdvertiserNamesStore')
        store.dispatch('offers/saveOfferExternalIdsStore')
        store.dispatch('offers/saveOfferManagerNamesStore')
        store.dispatch('offers/saveOfferVerticalNamesStore')
        store.dispatch('offers/saveOfferProgramNamesStore')
        store.dispatch('offers/saveOfferStatusesStore')
        store.dispatch('offers/saveOfferTypeStore')
        store.dispatch('offers/saveOfferNamesStore')
        store.dispatch('offers/saveOfferPaysInStore')
        store.dispatch('offers/saveOfferPaysOutStore')
        store.dispatch('offers/saveOfferCurrenciesStore')


      }
    }

  }
</script>

<style scoped lang="sass">
  .container_wrap
    margin-top: 0 !important
    padding-top: 0 !important
    max-width: 100%
    padding-left: 0
    padding-right: 0
    button.btn.btn-primary
      margin-top: 15px
.report-table
  .v-data-table__wrapper
    height: 56vh
    overflow: auto

.status-change-container
  display: flex
  align-items: center
  gap: 10px
  margin-top: 16px
.mr-3
  margin-right: 10px
.ml-2
  margin-left: 10px

</style>
